const configData =  {
    baseURL: 'https://app.priscilla.fitped.eu',
    jailSocketConnection: 'wss://vpl.ki.fpvai.ukf.sk/',// 'wss://henry.ukf.sk:11443/'//'wss://demojail.dis.ulpgc.es/', //'wss://henry.ukf.sk:11443/' //'wss://demojail.dis.ulpgc.es/' // wss://henry.ukf.sk:11443/
    jailRunSocketConnection: 'wss://vpl.ki.fpvai.ukf.sk/',// 'wss://henry.ukf.sk:11443/' //'wss://demojail.dis.ulpgc.es/', //'wss://henry.ukf.sk:11443/' //'wss://demojail.dis.ulpgc.es/' // wss://henry.ukf.sk:11443/
    client_secret: "iQuGUAzqc187j7IKQ94tTVJAywHCAzYBGAMTxEtr",
    baseKernelGatewayURL : 'https://jkg.fpvai.ukf.sk:8888',//'http://127.0.0.1:8888',
    baseKernelGatewayWS : 'wss://jkg.fpvai.ukf.sk:8888'//'ws://127.0.0.1:8888',
}

export default configData